import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { FilterData } from '../app-interface';
import { MagicNumber } from '../app-magic-string';
import * as moment from 'moment';

@Injectable({
  providedIn: 'root'
})
export class OrderManagementService {

  constructor(private readonly _http: HttpClient) { }

  /**
   *API Call for QR Code Management
  */

  getData(params: FilterData) {
    return this._http.get(`${environment.apiUrl}order-management?${params}`);
  }

  updateOrderStatus(params) {
    return this._http.post(`${environment.apiUrl}update-shipping-status?${params}`, null);
  }

  /**
   * reset params of filter data
   * @param data is Filter data
  */
  resetParams(data: FilterData) {
    data.duration = null;
    data.status = null;
    data.page = MagicNumber.one;
    data.download_csv = null;
    data.order = null;
    data.order_by = null;
    data.search = null;
    data.payment_mode = null;
    data.admin_shipping_status = null;
    data.account_type = null;
    data.vendor_id = null;
  }

  exportOrder(params?: any) {
    const timezone = moment.tz.guess(); // Get the local timezone
    const apiUrl = `${environment.apiUrl}export-order-management-list?timezone=${timezone}`;
  
    const requestUrl = params ? `${apiUrl}&${params}` : apiUrl;
  
    this._http.get(requestUrl, {
      responseType: 'arraybuffer' // Expecting an array buffer response for file download
    }).subscribe(response => this.downLoadFile(response, 'application/ms-excel', 'Order management.xlsx'));
  }
  
  downLoadFile(data: any, type1: string, filename: string) {
    const blob = new Blob([data], { type: type1 });
    const url = window.URL.createObjectURL(blob);
    
    const a = document.createElement('a'); // Create an anchor element
    a.href = url;
    a.download = filename; // Set the file name
    document.body.appendChild(a); // Append it to the DOM
    a.click(); // Trigger download
    document.body.removeChild(a); // Clean up by removing the anchor element
    window.URL.revokeObjectURL(url); // Revoke the object URL to free memory
  }
}
